/* ─────────────────────────────────────────────────────────────────────────
   Pavos theme — global behaviours.
   Small, dependency-free. Section-specific behaviour lives in per-section
   asset files; this file provides shared primitives.
   ──────────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  /* Scroll reveal — any element with [data-reveal]. Optional
     data-reveal-delay="120" (ms). */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-reveal]:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = el.getAttribute('data-reveal-delay');
          if (delay) el.style.transitionDelay = delay + 'ms';
          el.classList.add('is-visible');
          io.unobserve(el);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* Drawer / modal helper.
     Trigger: [data-drawer-open="#id"]  Close: [data-drawer-close]
     The target gets .is-open and aria-hidden toggled; body gets
     .drawer-locked (overflow hidden). */
  function openDrawer(target) {
    if (!target) return;
    target.classList.add('is-open');
    target.removeAttribute('aria-hidden');
    document.body.classList.add('drawer-locked');
    document.body.style.overflow = 'hidden';
    var focusable = target.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusable) focusable.focus();
  }

  function closeDrawer(target) {
    if (!target) return;
    target.classList.remove('is-open');
    target.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-locked');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(document.querySelector(opener.getAttribute('data-drawer-open')));
      return;
    }
    var closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.closest('.drawer, .modal, [data-drawer]'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.is-open[data-drawer]').forEach(closeDrawer);
  });

  /* Header: translucency once scrolled */
  function initHeaderScroll() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 4);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Cart helpers — Section Rendering API keeps drawer markup server-driven. */
  window.PavosCart = {
    add: function (formData) {
      return fetch(window.Shopify ? '/cart/add.js' : '/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add-to-cart failed');
          return r.json();
        })
        .then(function (item) {
          return window.PavosCart.refreshDrawer().then(function () {
            document.dispatchEvent(
              new CustomEvent('pavos:cart:added', { detail: item })
            );
            return item;
          });
        });
    },
    refreshDrawer: function () {
      return fetch(window.location.pathname + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var html = sections['cart-drawer'];
          if (!html) return;
          var current = document.getElementById('CartDrawer');
          if (!current) return;
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var next = parsed.getElementById('CartDrawer');
          if (next) current.innerHTML = next.innerHTML;
          document.dispatchEvent(new CustomEvent('pavos:cart:refreshed'));
        });
    },
    openDrawer: function () {
      openDrawer(document.getElementById('CartDrawer'));
    }
  };

  window.PavosUI = {
    initReveal: initReveal,
    openDrawer: openDrawer,
    closeDrawer: closeDrawer
  };

  function init() {
    initReveal(document);
    initHeaderScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run reveal for content swapped in by the theme editor */
  document.addEventListener('shopify:section:load', function (event) {
    initReveal(event.target);
  });
})();
